import { render, staticRenderFns } from "./DashboardChart.vue?vue&type=template&id=4936cb58"
import script from "./DashboardChart.vue?vue&type=script&lang=js"
export * from "./DashboardChart.vue?vue&type=script&lang=js"
import style0 from "./DashboardChart.vue?vue&type=style&index=0&id=4936cb58&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports